import { EnvironmentTypes } from '../constants/environmentTypes';

const liveEnvironment = (gameNameForUrl) => ({
  httpUrl: `${window.location.origin}/${gameNameForUrl}`,
  socketUrl: `${window.location.origin}/${gameNameForUrl}/api/`,
  chatHttpUrl: `${window.location.origin}/chat`,
  chatSocketUrl: `${window.location.origin}/chat/api/hubs/chat`,
  httpTranslationUrl: `${window.location.origin}/translations/api/v1/Translations`,
  liveUpdateSocketUrl: `${window.location.origin}/liveupdateservice/liveupdate`,
});

const stageEnvironment = (gameNameForUrl) => ({
  httpUrl: `https://pg-stage.rpd.cloud/${gameNameForUrl}`, // this
  socketUrl: `https://pg-stage.rpd.cloud/${gameNameForUrl}/api/`, // this
  chatHttpUrl: 'https://pg-stage.rpd.cloud/chat',
  chatSocketUrl: 'https://pg-stage.rpd.cloud/chat/api/hubs/chat',
  httpTranslationUrl: 'https://pg-stage.rpd.cloud/translations/api/v1/Translations',
  liveUpdateSocketUrl: 'https://pg-stage.rpd.cloud/liveupdateservice/liveupdate',
});

export const environmentBuilder = (gameNameForUrl) => {
  if (process.env.REACT_APP_ENV === EnvironmentTypes.Production) {
    return liveEnvironment(gameNameForUrl);
  }

  return stageEnvironment(gameNameForUrl);
};
